import { createAsyncThunk } from "@reduxjs/toolkit";
import { services } from "./service";

export const getAllBusinesses = createAsyncThunk("business/getAllBusinesses", async (obj) => {
  try {
    //console.log(obj)
    return await services.getAll(obj);
  } catch (error) {}
});

export const createNewBusiness = createAsyncThunk(
  "business/createNewBusiness",
  async (obj) => {
    try {
      //console.log(obj)
      return await services.createBusiness(obj);
    } catch (error) {}
  }
);

export const onUpdateBusiness = createAsyncThunk(
  "business/onUpdateBusiness",
  async (obj) => {
    try {
      return await services.updateBusiness(obj);
    } catch (error) {}
  }
);

export const BusinessBySlugId = createAsyncThunk(
  "business/BusinessBySlugId",
  async (obj) => {
    try {
      return await services.getBusinessBySlugId(obj);
    } catch (error) {}
  }
);
